export const isTouchDevice = () => {
  return document && 'ontouchstart' in document.documentElement
}
